export default __webpack_public_path__ + "static/logo-108de73dfad8662418b0d27034002371.svg";